import { useQueryParamHelper } from '@shared/core/queryString';
import { CardFormat } from '../../../ProductDetailsPage/constants';
import { useUpdateSearchParam } from '@shared/utils/updateSearchParam';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

// Basic digital is not included. `premiumDigital` intentended to cover both.
export type CardFormatWithAll = CardFormat.premiumDigital | CardFormat.paper | 'all' | undefined;

const SEARCH_PARAM_KEY = 'format';

export function toCount(format: CardFormatWithAll): number {
  if (!format) return 0;
  if (format === 'all') return 2;
  return 1;
}

export function toFormatList(format: CardFormatWithAll): CardFormat[] {
  if (!format || format === 'all') return [CardFormat.premiumDigital, CardFormat.paper];
  return [format];
}

export function useFormatSearchParam() {
  const queryParams = useQueryParamHelper();
  const format = queryParams.getValueString(SEARCH_PARAM_KEY) as CardFormatWithAll;

  const updateSearchParam = useUpdateSearchParam();
  const setFormat = useEventCallback((nextFormat?: CardFormat.premiumDigital | CardFormat.paper) => {
    // Basicallly converting 2 booleans into 4-item enum
    const value = (() => {
      if (!nextFormat) return null;

      if (format === 'all') {
        // deselect just the one that was clicked on
        return nextFormat === CardFormat.premiumDigital ? CardFormat.paper : CardFormat.premiumDigital;
      }
      if (format) {
        return format === nextFormat ? null : 'all';
      }
      return nextFormat;
    })();

    updateSearchParam(SEARCH_PARAM_KEY, value, 'replace');
  });

  return [format, setFormat] as const;
}
